import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {MarketingTitle} from 'shells/typography/marketing-title';
import {ModalTitle} from 'shells/typography/modal-title';

import type {UserEmail as UserEmailFragment} from 'nutshell-graphql-types';

import styles from './bcc-import.module.css';

type Props = {
    emails: UserEmailFragment[];
};

BccImport.defaultProps = {
    emails: [],
};

export function BccImport(props: Props) {
    const emailAddresses = props.emails.map((email) => email.address);

    return (
        <React.Fragment>
            <MarketingTitle>Import email via BCC</MarketingTitle>
            <div className={styles['email-list-container']}>
                <Body as='div'>
                    Don’t want to set up email sync? Not a problem! Send your outgoing messages into
                    Nutshell by adding <b>bcc@nutshell.com</b> to your email’s bcc field, and
                    forward received emails to <b>bcc@nutshell.com</b> as well.{' '}
                    <Link
                        variant='primary'
                        href='https://support.nutshell.com/en/articles/8428953-how-to-bcc-your-emails-into-nutshell'
                    >
                        Learn more
                    </Link>
                </Body>
                {/* I know, I know */}
                <ModalTitle>Addresses configured for BCC:</ModalTitle>
                <BulletedList size='normal' bullets={emailAddresses} />
            </div>
            <div className={styles.adder}>
                <Link
                    variant='primary'
                    to='/my-account/settings'
                    // @ts-expect-error
                    as={RoutedLink}
                    onClick={() => {
                        window.scrollTo(0, 0);
                    }}
                >
                    Add/remove address
                </Link>
            </div>
        </React.Fragment>
    );
}
